function luxomodTrack(eventName, detail) {
  detail = detail || {};
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(Object.assign({ event: 'luxomod_' + eventName }, detail));
  document.dispatchEvent(new CustomEvent('luxomod:' + eventName, { detail: detail }));

  if (typeof window.fbq === 'function') {
    if (eventName === 'view_content') {
      window.fbq('track', 'ViewContent', detail);
    } else if (eventName === 'initiate_checkout') {
      window.fbq('track', 'InitiateCheckout', detail);
    } else {
      window.fbq('trackCustom', 'LuxoMod_' + eventName, detail);
    }
  }
}

window.LuxoModTracking = luxomodTrack;

function activateColor(idSuffix, colorName, btnElement) {
  document.querySelectorAll('.ic-stage img').forEach(img => img.classList.remove('active'));
  document.querySelectorAll('[id="bag-' + idSuffix + '"]').forEach(target => target.classList.add('active'));
  document.querySelectorAll('[id="ic-title"]').forEach(title => { title.innerText = colorName; });
  document.querySelectorAll('.ic-btn').forEach(btn => btn.classList.remove('active'));
  document.querySelectorAll('.ic-btn').forEach(btn => {
    if (btn.getAttribute('onclick') && btn.getAttribute('onclick').includes("'" + idSuffix + "'")) btn.classList.add('active');
  });
  luxomodTrack('variant_select', { color: colorName, content_name: 'Sac Élégance', value: 249, currency: 'MAD' });
}

document.addEventListener('DOMContentLoaded', function () {
  luxomodTrack('view_content', { content_name: 'Sac Élégance', content_type: 'product', value: 249, currency: 'MAD' });

  document.addEventListener('click', function (event) {
    var cta = event.target.closest('a[href*="#checkout"], .lm-product-buy');
    if (cta) luxomodTrack('cta_click', { content_name: 'Sac Élégance', value: 249, currency: 'MAD' });
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('select[name="variant"], .lm-product-variant')) {
      var option = event.target.options[event.target.selectedIndex];
      luxomodTrack('variant_select', { variant_id: event.target.value, color: option ? option.textContent.trim() : '', content_name: 'Sac Élégance', value: 249, currency: 'MAD' });
    }
  });

  document.querySelectorAll('.luxomod-order-form').forEach(function (form) {
    var started = false;
    form.addEventListener('focusin', function () {
      if (!started) {
        started = true;
        luxomodTrack('form_start', { content_name: 'Sac Élégance', value: 249, currency: 'MAD' });
      }
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.luxomod-order-form');
    if (!form) return;
    var variant = form.elements.variant ? form.elements.variant.value : '';
    luxomodTrack('initiate_checkout', { content_name: 'Sac Élégance', content_ids: variant ? [variant] : [], content_type: 'product', value: 249, currency: 'MAD' });
  }, true);
});
